import React from 'react'
import { tokens } from '@/locales/translations/tokens'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import FileIcon from '@/utils/file-extension-icons'
import { Button } from '@/components/ui/button'
import { BaseCardHeader } from './base-card-header'

interface DocumentCardHeaderProps {
  title: string
  backgroundColor?: string
  sourceUrl: string
  relevanceValue: number
  groupedCards?: unknown[]
  currentCardIndex: number
  onClose: () => void
}

export const DocumentCardHeader: React.FC<DocumentCardHeaderProps> = ({
  sourceUrl,
  title,
  ...baseProps
}) => {
  const { t } = useTranslation()
  const extension = title.includes('.')
    ? title.split('.').pop()?.toUpperCase()
    : undefined

  return (
    <BaseCardHeader {...baseProps} title={title}>
      <div className='absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.18),transparent_28%),radial-gradient(circle_at_70%_35%,rgba(255,255,255,0.12),transparent_20%),linear-gradient(135deg,rgba(255,255,255,0.16),rgba(255,255,255,0.02))]' />

      <div className='absolute inset-x-0 bottom-0 top-0 flex items-center gap-4 px-6 py-6 sm:px-8'>
        <div className='flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm'>
          <FileIcon fileName={title} size={40} className='h-10 w-10' />
        </div>

        <div className='min-w-0 flex-1 pt-10'>
          {extension && (
            <p className='mb-2 text-xs font-medium uppercase tracking-[0.24em] text-white/70'>
              {extension}
            </p>
          )}

          {sourceUrl && (
            <Button
              asChild
              size='sm'
              variant='secondary'
              className='bg-white/12 h-9 gap-2 border border-white/20 text-white shadow-none backdrop-blur-sm hover:bg-white/20'
            >
              <a href={sourceUrl} target='_blank' rel='noopener noreferrer'>
                {t(tokens.workstation.sources.goToSource)}
                <ExternalLink size={14} />
              </a>
            </Button>
          )}
        </div>
      </div>
    </BaseCardHeader>
  )
}
